import { FieldErrors } from 'react-hook-form';

export const getNestedFormErrors = (fieldErrors: FieldErrors, fieldName: string): string | undefined => {
  const nameParts = fieldName.split(/[[\].]+/).filter(Boolean);

  if (nameParts.length === 1) {
    return (fieldErrors[nameParts[0]] as { message?: string })?.message;
  }

  const currentError = nameParts.reduce((acc, part) => {
    if (!acc || typeof acc !== 'object' || !(part in acc)) return undefined;
    return acc[part];
  }, fieldErrors as Record<string, any>);

  if (!currentError || typeof currentError !== 'object') return undefined;

  return (currentError as { message?: string }).message;
};
